var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLivecasino(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4910",
    "data-name": "Group 4910",
    transform: "translate(-255 -752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4762",
    "data-name": "Group 4762",
    transform: "translate(23212 64)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4362",
    "data-name": "Rectangle 4362",
    width: 24,
    height: 24,
    transform: "translate(-22957 688)",
    fill: "none",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4764",
    "data-name": "Group 4764",
    transform: "translate(-22952.971 691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4765",
    "data-name": "Group 4765",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6694",
    "data-name": "Path 6694",
    d: "M7.971,0c14.093,7.688,6.177,17.07,1.366,13.475a2.26,2.26,0,0,0-2.732,0C1.794,17.07-6.123,7.688,7.971,0",
    transform: "translate(0 0)",
    fill: "rgba(151,161,194,0.4)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6695",
    "data-name": "Path 6695",
    d: "M17.208,35.54c0-1.759-1.791-3.185-4-3.185s-4,1.426-4,3.185Z",
    transform: "translate(-5.237 -18.402)",
    fill: "#97a1c2"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLivecasino);
export default __webpack_public_path__ + "static/media/livecasino.69cba188d8755b4e35bea1d21bc8b732.svg";
export { ForwardRef as ReactComponent };